import React from "react"
import ReCAPTCHA from "react-google-recaptcha"
import PropTypes from "prop-types"
import useForm from "react-hook-form"
import {
  InputAdornment,
  IconButton,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import { sessionStorage, localStorage } from "../../../state/utils/storage"
import * as constants from "../../../state/constants/appConstants"
import { AUTH_EMAIL, AUTH_LOGIN } from "../../../state/constants/apiConstants"
import axios from "axios"
import Icon from "../../atoms/Icon/Icon"
import Button from "../../atoms/Button/Button"
import ButtonLoading from "../../molecules/buttonLoading/buttonLoading"
import "./loginSection.scss"
import useHomeLinkMode from "../../../hooks/useHomeLinkMode"
import AuthService from "../../../services/authentication"
import { isAdviser } from '../../../state/utils/isAdviser'

const LoginSection = props => {
  const recaptchaRef = React.useRef(null);
  const { homeLink } = useHomeLinkMode();
  React.useEffect(() => {
    recaptchaRef.current.execute()
  }, []);

  const {
    title,
    sectionType,
    handleNextButton,
    handlePrevButton,
    handleToggleLoader,
    handleChangeContent,
    handleRegisteredEmail,
    isRegisteredEmail,
    handlePassStatus,
    isCorrectPassword,
    isShowingLoader,
    handlePopUpFalse,
  } = props;

  const [values, setValues] = React.useState({
    email: "",
    password: "",
    showPassword: false,
    checkAccount: false,
    emailErrorMsg: "",
    passwordErrorMsg: "",
  });
  const refEmailInput = React.useRef();
  const refForm = React.useRef();
  const {
    register,
    handleSubmit,
    errors,
    triggerValidation,
    formState,
  } = useForm({});
  const onSubmit = data => {
    handleToggleLoader(true);
    if (data.email) {
      const payload = {
        email: data.email,
        captcha: recaptchaRef.current.getValue(),
      };
      axios
        .post(AUTH_EMAIL, payload)
        .then(restData => {
          recaptchaRef.current.execute();
          const { data } = restData;
          if (restData.data.status === 200) {
            handleRegisteredEmail(false);
            if(restData.data.data && restData.data.data.estado === "MIGRACION"){
              sessionStorage.setItem("migrationData", JSON.stringify(restData.data.data));
              window.location.href = homeLink + 'registro/';
            }
            else{
              handleNextButton()
            }
          } else if (restData.data.status === 400) {
              handleRegisteredEmail(true);
              setValues({ ...values, emailErrorMsg: data.userMessage })       
          }
          handleToggleLoader(false)
        })
        .catch(err => {
          console.log(err);
          handleToggleLoader(false)
        })
    } else if (data.password && !isRegisteredEmail) {
      let email = document.querySelector("#form-login-email").elements[1].value;
      const payload = {
        email: email,
        password: data.password,
        captcha: recaptchaRef.current.getValue(),
      };
      axios
        .post(AUTH_LOGIN, payload)
        .then(restData => {
          recaptchaRef.current.execute();
          const { data } = restData;
          const authData = data.data;
          if (data.status === constants.successStatus) {
            handlePassStatus(false);
            AuthService.userInfo(
              payload.email,
              authData.tokenData.idToken
            ).then(resp => {
              if (resp.status === constants.successStatus) {
                const userData = resp.data;
                //when the checkbox is true the default storage is Localstorage

                if (values.checkAccount) {
                  localStorage.setItem("tokenData", authData.tokenData);
                  localStorage.setItem("userData", userData);
                  sessionStorage.removeItem("tokenData");
                  sessionStorage.removeItem("userName");
                  sessionStorage.removeItem("userData");
                  if (authData.roles[0].nombreRol === constants.ROL_CUIDADOR_FAMILIAR.nombreRol ||
                    authData.roles[0].nombreRol === constants.ROL_CUIDADOR_PROFESIONAL.nombreRol ||
                    authData.roles[0].nombreRol === constants.ROL_INSTITUCION.nombreRol) {
                    localStorage.setItem("userName", `${userData.name}`);
                  }
                  else {
                    localStorage.setItem("userName", `${userData.name} ${userData.lastName}`);
                  }
                }
                else {
                  sessionStorage.setItem("tokenData", authData.tokenData);
                  sessionStorage.setItem("userData", userData);
                  localStorage.removeItem("tokenData");
                  localStorage.removeItem("userName");
                  localStorage.removeItem("userData");
                  if (authData.roles[0].nombreRol === constants.ROL_CUIDADOR_FAMILIAR.nombreRol ||
                    authData.roles[0].nombreRol === constants.ROL_CUIDADOR_PROFESIONAL.nombreRol ||
                    authData.roles[0].nombreRol === constants.ROL_INSTITUCION.nombreRol) {
                    sessionStorage.setItem("userName", `${userData.name}`);
                  }
                  else {
                    sessionStorage.setItem("userName", `${userData.name} ${userData.lastName}`);
                  }
                }

                if (isAdviser(authData.tokenData.idToken)) {
                  window.location.href = homeLink + 'callcenter';
                }

                //when cambioClave is 1 then it should be directed to change password
                if (authData.cambioClave === 0) {
                  handleToggleLoader(false);
                  let forms = document.querySelectorAll('.f-form-login');
                  forms[0].reset();
                  forms[1].reset();
                  if (authData.roles[0].nombreRol === constants.ROL_USUARIO.nombreRol ||
                    authData.roles[0].nombreRol === constants.ROL_COMPRADOR.nombreRol ||
                    authData.roles[0].nombreRol === constants.ROL_INTERESADO.nombreRol) {
                    switch (authData.gender) {
                      case "Masculino":
                        window.location.href = homeLink + 'hombres';
                        break;
                      case "Femenino":
                        window.location.href = homeLink + 'mujeres';
                        break;
                      default:
                        break;
                    }
                  }
                  else {
                    switch (authData.roles[0].nombreRol) {
                      case constants.ROL_CUIDADOR_FAMILIAR.nombreRol:
                        window.location.href = homeLink + 'cuidadores/cuidas-a-un-ser-querido';
                        break;
                      case constants.ROL_CUIDADOR_PROFESIONAL.nombreRol:
                        window.location.href = homeLink + 'cuidadores/eres-un-profesional';
                        break;
                      case constants.ROL_INSTITUCION.nombreRol:
                      case constants.ROL_ADMINISTRADOR_INSTITUCION.nombreRol:
                      case constants.ROL_COLABORADOR_INSTITUCION.nombreRol:
                        window.location.href = homeLink + 'cuidadores/institucion';
                        break;
                      default:
                        break;
                    }
                  }
                  handleToggleLoader(false);
                  handlePrevButton();
                  handleChangeContent(0);
                  handlePopUpFalse();
                } else {
                  sessionStorage.setItem("__tmp", payload.password);
                  // navigate("cambio-contrasena", { state: { password: payload.password } })
                  handleToggleLoader(false);
                  handlePrevButton();
                  handleChangeContent(0);
                  handlePopUpFalse();
                  window.location.href = homeLink + 'cambio-contrasena';
                }
              }
            })
          } else if (data.status === constants.failureStatus) {
            handlePassStatus(true);
            handleToggleLoader(false);
            setValues({ ...values, passwordErrorMsg: data.userMessage })
          }
        })
        .catch(err => console.log(err))
    }
  };

  const handleChange = prop => event => {
    triggerValidation({ name: event.target.name });
    if (event.target.type === "checkbox") {
      setValues({ ...values, [event.target.name]: event.target.checked })
    }
    if (event.target.name === "email") {
      setValues({ ...values, [event.target.name]: event.target.value });
      handleRegisteredEmail(false)
    }
    if (event.target.name === "password") {
      setValues({ ...values, [event.target.name]: event.target.value });
      handlePassStatus(false)
    }
  };
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword })
  };

  const handleMouseDownPassword = event => {
    event.preventDefault()
  };

  return (
    <form
      id={`form-login-${sectionType === 0 ? "email" : "password"}`}
      ref={refForm}
      className="f-form-login"
      onSubmit={handleSubmit(onSubmit)}
    >
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey="6LdO87YUAAAAADiKJPkEhXpUH7_JthcTOF1iVMnx"
      />
      <h3>{title}</h3>
      {/* <p>{JSON.stringify(formState)}</p> */}
      {sectionType === 0 ? (
        <>
          <TextField
            error={
              errors.email != null ||
              (isRegisteredEmail && formState.isSubmitted)
            }
            color="secondary"
            name="email"
            type="text"
            autoComplete="off"
            className="f-form-input"
            id="f-email-input"
            onChange={handleChange()}
            label="Ingresa con tu correo o cédula"
            variant="outlined"
            ref={refEmailInput}
            helperText={
              errors.email && errors.email.type === "required"
                ? "El campo es requerido"
                : ""
            }
            inputRef={register({
              required: true,
            })}
          />
          <div className="f-footer-login">
            <p
              className="nocenter"
              onClick={() => {
                handleChangeContent(1)
              }}
            >
              ¿Olvidaste tu correo electrónico?
            </p>
            <hr className="separator" />
            <ButtonLoading
              isEnabled={false}
              button={
                <Button
                  id="f-login-submit-btn"
                  type="input"
                  classname="f-button f-button--primary"
                  text="Siguiente"
                />
              }
              isShowingLoader={isShowingLoader}
              bgClass="primary"
            />
          </div>
        </>
      ) : (
          <>
            <TextField
              error={
                errors.password != null ||
                (isCorrectPassword && formState.isSubmitted)
              }
              color="secondary"
              name="password"
              className="f-form-input"
              id="f-password-input"
              variant="outlined"
              type={values.showPassword ? "text" : "password"}
              onChange={handleChange()}
              label={"Ingresa tu contraseña"}
              helperText={
                errors.password && errors.password.type === "required"
                  ? "Una contraseña es requerida"
                  : isCorrectPassword && formState.isSubmitted
                    ? values.passwordErrorMsg
                    : ""
              }
              inputRef={register({ required: true })}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {values.showPassword ? (
                        <VisibilityOff className="f-btn-password" />
                      ) : (
                          <Visibility className="f-btn-password" />
                        )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <FormControlLabel
              className="f-formcontrol-account"
              control={
                <Checkbox
                  id="f-account-checkbox"
                  name="checkAccount"
                  color="primary"
                  checked={values.checkAccount}
                  onChange={handleChange()}
                  value={values.checkAccount}
                  className={
                    values.checkAccount
                      ? "f-account-checkbox"
                      : "f-account-checkbox f-terms-account-error"
                  }
                />
              }
              label="Quiero mantenerme conectado con mi cuenta"
            />

            <div className="f-footer-login second">
              <Icon
                tagtype="span"
                icon="icon-arrow-left f-arrow-left"
                size="1-2"
                onclick={handlePrevButton}
              />
              <p
                onClick={() => {
                  handleChangeContent(2)
                }}
              >
                ¿Olvidaste tu contraseña?
            </p>
              <ButtonLoading
                isEnabled={false}
                button={
                  <Button
                    id="f-login-submit-btn"
                    type="input"
                    classname="f-button f-button--primary"
                    text="Siguiente"
                    />
                  }
                isShowingLoader={isShowingLoader}
                bgClass="primary"
              />
              <hr className="separator" />
            </div>
          </>
        )}
    </form>
  )
};

LoginSection.propTypes = {
  title: PropTypes.string.isRequired,
  sectionType: PropTypes.number.isRequired,
  handleNextButton: PropTypes.func,
  handlePrevButton: PropTypes.func,
  handleToggleLoader: PropTypes.func,
  handleRegisteredEmail: PropTypes.func,
  handlePassStatus: PropTypes.func,
  handleChangeContent: PropTypes.func,
  handlePopUpFalse: PropTypes.func,
  isRegisteredEmail: PropTypes.bool,
  isCorrectPassword: PropTypes.bool,
  isShowingLoader: PropTypes.bool,
};

export default LoginSection
